export const ICON_NAMES = {
	email: "email",
	moon: "moon",
	sun: "sun",
	location: "location",
	info: "info",
	linkedin: "linkedin",
	facebook: "facebook",
	instagram: "instagram",
	x: "x",
	youtube: "youtube",
	clock: "clock",
	panelBattery: "panelBattery",
	batteryCharge: "batteryCharge",
	check: "check",
} as const;

export const ICON_FILENAMES: Record<keyof typeof ICON_NAMES, string> = {
	email: "email",
	moon: "moon",
	sun: "sun",
	location: "location",
	info: "info",
	linkedin: "linkedin",
	facebook: "facebook",
	instagram: "instagram",
	x: "x",
	youtube: "youtube",
	clock: "clock",
	panelBattery: "panel-battery",
	batteryCharge: "battery-charge",
	check: "check",
};
